module.exports = __webpack_public_path__ + "img/map-marker.e1df4149.png";